import { Component, Input, OnInit } from '@angular/core';
import { EmailActivityLogEmailVM } from 'src/app/models/activities';
import { ApplicationLogEmailVM, LogEmailVM } from 'src/app/models/log-email';
import { WorkflowContextService } from 'src/app/services';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
  selector: 'wm-log-email-view',
  templateUrl: './log-email-view.component.html',
  styleUrl: './log-email-view.component.css',
  standalone: false
})
export class LogEmailViewComponent implements OnInit {
  @Input() logEmail: EmailActivityLogEmailVM | ApplicationLogEmailVM | LogEmailVM;

  showEmailApplicantValue = false;
  emailApplicantValue: boolean;
// Added by amisha on 24/12/2025
  templateForPermitForm = false;

  constructor( public layoutService: LayoutService, context: WorkflowContextService) {
    layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
  }

  ngOnInit() {
    // Added by amisha on 24/12/2025
  

    if ('emailApplicant' in this.logEmail) {
      this.showEmailApplicantValue = true;
      this.emailApplicantValue = this.logEmail.emailApplicant;
    }
  }
}

